import { SettingsRepository } from "../repositories/SettingsRepository";

export class SaveAdminLiveFaceResult {
	constructor(private repository: SettingsRepository) {}

	execute(params: SaveAdminLiveFaceResultParams): Promise<string> {
		return this.repository.saveAdminLiveFaceResult(params.sessionId);
	}
}

export class SaveAdminLiveFaceResultParams {
	constructor(public sessionId: string) {}
}
